import styled from 'styled-components'
import { Button } from '@compeon-os/components'

const StyledSubmitButton = styled(Button)`
  padding: 7.5px;
  margin: 13px 0;
  width: 300px;

  @media (min-width: 768px) {
    width: 100%;
  }

  @media (min-width: 992px) {
    margin-bottom: 13px;
  }
`

export default StyledSubmitButton
